(function(){
  var r = document.querySelector('[data-vh]'); if (!r) return;
  var hdr = r.querySelector('[data-hdr]'), sp = r.querySelector('.hspace');
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var WA = r.getAttribute('data-wa') || '#';
  var mq = matchMedia('(min-width:990px)'), hov = matchMedia('(hover:hover)');

  /* altura reservada + header pegado */
  function size(){ if (sp) sp.style.height = hdr.querySelector('.header__bar').offsetHeight + 12 + 'px'; }
  var stuck = false;
  function onS(){ var s = window.scrollY > 60; if (s !== stuck) { stuck = s; hdr.classList.toggle('is-stuck', s); } }
  size(); onS(); addEventListener('scroll', onS, { passive: true }); addEventListener('resize', size); addEventListener('load', size);

  /* anuncios: cada 5s, pausa al pasar el mouse o al salir de pantalla */
  var ann = r.querySelector('[data-ann]');
  if (ann) {
    var items = ann.querySelectorAll('.ann__item'), ai = 0, hold = false, vis = true;
    ann.addEventListener('mouseenter', function(){ hold = true; });
    ann.addEventListener('mouseleave', function(){ hold = false; });
    ann.addEventListener('focusin', function(){ hold = true; });
    ann.addEventListener('focusout', function(){ hold = false; });
    if ('IntersectionObserver' in window) new IntersectionObserver(function(e){ vis = e[0].isIntersecting; }).observe(ann);
    if (items.length > 1) setInterval(function(){
      if (hold || !vis || document.hidden) return;
      items[ai].classList.remove('is-on'); items[ai].setAttribute('inert', '');
      ai = (ai + 1) % items.length;
      items[ai].classList.add('is-on'); items[ai].removeAttribute('inert');
    }, 5000);
  }

  /* desplegables: abre a los 140ms (0 si ya hay uno abierto), cierra a los 320ms */
  var btns = [].slice.call(r.querySelectorAll('[data-dd]')), openT, closeT, cur = null;
  function panel(b){ return document.getElementById(b.getAttribute('aria-controls')); }
  function closeDD(){ clearTimeout(openT); btns.forEach(function(b){ b.setAttribute('aria-expanded', 'false'); var d = panel(b); d.hidden = true; d.classList.remove('is-open'); }); cur = null; }
  function openDD(b){ if (cur === b) return; closeDD(); closeRes(); b.setAttribute('aria-expanded', 'true'); var d = panel(b); d.hidden = false; d.classList.add('is-open'); cur = b; }
  btns.forEach(function(b){
    var d = panel(b);
    b.addEventListener('click', function(e){ e.stopPropagation(); cur === b ? closeDD() : openDD(b); });
    b.addEventListener('mouseenter', function(){ if (!hov.matches) return; clearTimeout(closeT); clearTimeout(openT); openT = setTimeout(function(){ openDD(b); }, cur ? 0 : 140); });
    b.addEventListener('mouseleave', function(){ clearTimeout(openT); closeT = setTimeout(closeDD, 320); });
    d.addEventListener('mouseenter', function(){ clearTimeout(closeT); });
    d.addEventListener('mouseleave', function(){ closeT = setTimeout(closeDD, 320); });
    d.addEventListener('keydown', function(e){
      if (e.key !== 'Tab') return;
      var f = d.querySelectorAll('a,button'); if (!f.length) return;
      if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); closeDD(); var n = btns[btns.indexOf(b) + 1] || b; n.focus(); }
    });
  });
  document.addEventListener('click', function(e){ if (!e.target.closest('.dd,[data-dd]')) closeDD(); });

  /* buscador */
  var tpl = r.querySelector('template[data-empty]');
  function esc(t){ return String(t).replace(/[&<>"]/g, function(c){ return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function norm(t){ return t.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase(); }
  function hl(t, q){ var n = norm(t), i = n.indexOf(norm(q)); if (!q || i < 0) return esc(t); return esc(t.slice(0, i)) + '<mark>' + esc(t.slice(i, i + q.length)) + '</mark>' + esc(t.slice(i + q.length)); }
  function money(v){ var n = Number(v); if (!isFinite(n)) return ''; return '$' + Math.round(n).toLocaleString('es-CO'); }
  var cat = null;
  function catalog(){ return cat || (cat = fetch(root + 'products.json?limit=250').then(function(x){ return x.json(); }).then(function(j){ return (j.products || []).map(function(p){ var v0 = (p.variants || [])[0] || {}; return { title: p.title, url: root + 'products/' + p.handle, image: p.images && p.images[0] && p.images[0].src, price: v0.price, vendor: p.vendor, t: norm(p.title + ' ' + (p.product_type || '') + ' ' + [].concat(p.tags || []).join(' ') + ' ' + String(p.body_html || '').replace(/<[^>]+>/g, ' ').slice(0, 600)) }; }); }).catch(function(){ return []; })); }
  var boxes = [];
  function closeRes(){ boxes.forEach(function(b){ b.close(); }); }
  r.querySelectorAll('[data-search]').forEach(function(sb){
    var q = sb.querySelector('input[name=q]'), out = sb.querySelector('[data-res]'), clr = sb.querySelector('[data-clear]'), kbd = sb.querySelector('.search__kbd');
    var inline = out.classList.contains('results--inline'), t, ac, sel = -1;
    function opts(){ return [].slice.call(out.querySelectorAll('[role=option]')); }
    function mark(i){ var o = opts(); o.forEach(function(x, k){ x.setAttribute('aria-selected', k === i ? 'true' : 'false'); }); sel = i; if (o[i]) o[i].scrollIntoView({ block: 'nearest' }); }
    function open(){ if (!out.hidden) return; out.hidden = false; out.classList.remove('is-open'); void out.offsetWidth; out.classList.add('is-open'); q.setAttribute('aria-expanded', 'true'); }
    function close(){ if (inline) return; out.hidden = true; out.classList.remove('is-open'); q.setAttribute('aria-expanded', 'false'); sel = -1; }
    function empty(){ out.innerHTML = tpl ? tpl.innerHTML : ''; sel = -1; }
    function render(){
      var v = q.value.trim();
      clr.hidden = !v; if (kbd) kbd.hidden = !!v;
      if (!v) { if (ac) ac.abort(); empty(); return; }
      clearTimeout(t);
      t = setTimeout(function(){
        if (ac) ac.abort(); ac = 'AbortController' in window ? new AbortController() : null;
        fetch(root + 'search/suggest.json?q=' + encodeURIComponent(v) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last', ac ? { signal: ac.signal } : {})
          .then(function(x){ return x.json(); }).then(function(j){
            var res = j.resources && j.resources.results || {}, ps = res.products || [], cs = res.collections || [];
            if (ps.length) return draw(ps, cs, v);
            return catalog().then(function(c){ var nv = norm(v); if (q.value.trim() === v) draw(c.filter(function(p){ return p.t.indexOf(nv) > -1; }).slice(0, 6), cs, v); });
          }).catch(function(){});
      }, 140);
    }
    function draw(ps, cs, v){
      var h = '';
      if (cs.length) h += '<h3>Categorías y marcas</h3><ul>' + cs.map(function(c){ return '<li role="option" class="text" data-href="' + esc(c.url) + '"><b>' + hl(c.title, v) + '</b><svg width="16" height="16"><use href="#vh-arrow"/></svg></li>'; }).join('') + '</ul>';
      if (ps.length) h += '<h3>Productos</h3><ul>' + ps.map(function(p){ return '<li role="option" data-href="' + esc(p.url) + '"><img src="' + esc(p.image || '') + '" alt="" loading="lazy"><b>' + hl(p.title, v) + (p.vendor ? '<small>' + esc(p.vendor) + '</small>' : '') + '</b><span class="p">' + money(p.price) + '</span></li>'; }).join('') + '</ul>';
      var all = root + 'search?type=product&q=' + encodeURIComponent(v);
      h += (ps.length || cs.length)
        ? '<p class="all"><span>Resultados de la tienda</span><a href="' + all + '">Ver todos los resultados →</a></p>'
        : '<p class="empty">No encontramos «' + esc(v) + '». ' + esc(r.getAttribute('data-none') || '') + ' <a href="' + esc(WA) + '" target="_blank" rel="noopener">WhatsApp</a></p>';
      out.innerHTML = h; sel = -1; open();
    }
    q.addEventListener('focus', function(){ closeDD(); if (!q.value.trim()) empty(); else if (!out.innerHTML) render(); open(); });
    q.addEventListener('input', render);
    q.addEventListener('keydown', function(e){
      var o = opts();
      if (e.key === 'ArrowDown') { e.preventDefault(); open(); mark(Math.min(sel + 1, o.length - 1)); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); mark(Math.max(sel - 1, 0)); }
      else if (e.key === 'Enter' && o[sel]) { e.preventDefault(); location.href = o[sel].getAttribute('data-href'); }
      else if (e.key === 'Escape') { close(); q.blur(); }
    });
    clr.addEventListener('click', function(){ q.value = ''; render(); q.focus(); open(); });
    out.addEventListener('mousedown', function(e){ e.preventDefault(); });
    out.addEventListener('click', function(e){
      var term = e.target.closest('[data-term]'); if (term) { q.value = term.getAttribute('data-term'); render(); q.focus(); return; }
      var o = e.target.closest('[role=option]'); if (o) location.href = o.getAttribute('data-href');
    });
    document.addEventListener('click', function(e){ if (!sb.contains(e.target)) close(); });
    var api = { close: close, q: q, empty: empty, open: open };
    boxes.push(api); sb._vh = api;
  });
  document.addEventListener('keydown', function(e){
    if (e.key === '/' && mq.matches && !/INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName) && !document.activeElement.isContentEditable) {
      var q = document.getElementById('q'); if (q && q.offsetParent) { e.preventDefault(); q.focus(); }
    }
    if (e.key === 'Escape') { closeDD(); if (!ms.hidden) closeMS(); if (!dr.hidden) closeDr(); }
  });

  /* trampa de foco */
  function trap(box, e){
    if (e.key !== 'Tab') return;
    var f = [].filter.call(box.querySelectorAll('a[href],button:not([disabled]),input:not([type=hidden])'), function(x){ return x.offsetParent !== null; });
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  }

  /* buscador móvil a pantalla completa */
  var ms = document.getElementById('msearch'), msOpen = r.querySelector('[data-msearch-open]');
  function openMS(){ closeDD(); ms.hidden = false; document.body.style.overflow = 'hidden'; var b = ms.querySelector('[data-search]')._vh; b.empty(); b.open(); setTimeout(function(){ document.getElementById('q-m').focus(); }, 30); }
  function closeMS(){ ms.hidden = true; document.body.style.overflow = ''; if (msOpen) msOpen.focus(); }
  if (msOpen) msOpen.addEventListener('click', openMS);
  ms.querySelector('[data-msearch-close]').addEventListener('click', closeMS);
  ms.addEventListener('keydown', function(e){ trap(ms, e); });

  /* menú lateral con pantallas */
  var dr = document.getElementById('vh-drawer'), body = dr.querySelector('[data-dbody]'), opener = r.querySelector('[data-open]'), stack = [];
  function screen(id, dir){
    var tp = r.querySelector('template[data-screen="' + id + '"]'); if (!tp) return;
    body.innerHTML = tp.innerHTML;
    var n = body.querySelector('.dnav'); if (dir && n) n.classList.add(dir === 'r' ? 'in-r' : 'in-l');
    var f = body.querySelector('[data-back],a,button'); if (f && dir) f.focus({ preventScroll: true });
    dr.scrollTop = 0;
  }
  function openDr(){ closeDD(); stack = ['root']; screen('root'); dr.hidden = false; dr.classList.remove('is-open'); void dr.offsetWidth; dr.classList.add('is-open'); document.body.style.overflow = 'hidden'; opener.setAttribute('aria-expanded', 'true'); dr.querySelector('[data-close]').focus(); }
  function closeDr(){ dr.hidden = true; dr.classList.remove('is-open'); document.body.style.overflow = ''; opener.setAttribute('aria-expanded', 'false'); opener.focus(); }
  if (opener) opener.addEventListener('click', openDr);
  dr.querySelector('[data-close]').addEventListener('click', closeDr);
  dr.addEventListener('keydown', function(e){ trap(dr, e); });
  body.addEventListener('click', function(e){
    var go = e.target.closest('[data-go]'); if (go) { stack.push(go.getAttribute('data-go')); screen(stack[stack.length - 1], 'r'); return; }
    if (e.target.closest('[data-back]')) { stack.pop(); screen(stack[stack.length - 1] || 'root', 'l'); }
  });
  mq.addEventListener && mq.addEventListener('change', function(){ if (mq.matches) { if (!dr.hidden) closeDr(); if (!ms.hidden) closeMS(); } size(); });

  /* efecto onda en botones */
  r.addEventListener('pointerdown', function(e){
    var b = e.target.closest('.btn'); if (!b || matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    var k = b.getBoundingClientRect(), s = document.createElement('span');
    s.className = 'ripple'; s.style.left = e.clientX - k.left + 'px'; s.style.top = e.clientY - k.top + 'px';
    b.appendChild(s); setTimeout(function(){ s.remove(); }, 650);
  });
})();
